import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';
import { getAllAgents } from '@/lib/services/agent.service';
import AgentLink from '@/components/agent-link';
import OnOffList from '../on-off-list';
import { FormProps } from '../helpers';
import { AssistantEntity } from '@/lib/models/policy-model/portal';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';

interface Props extends FormProps {
  value: AssistantEntity[] | undefined;
  onChange: (access: AssistantEntity[] | undefined) => void;
  policy: PolicyModel;
}

const AgentEntityList: FC<Props> = ({ value, onChange, policy, ...rest }) => {
  const query = useQuery([QueryKey.AgentsList], async () => getAllAgents());
  const { data: agents } = query;

  const agentOptions = useMemo(() => {
    return (agents || []).map((agent) => {
      const { id, portalTitle } = agent;

      return {
        value: id,
        label: <AgentLink agent={agent} showAdminName />,
        labelSimple: portalTitle,
      };
    });
  }, [agents]);

  const { isDefault: isDefaultPolicy } = policy;

  return (
    <OnOffList
      {...rest}
      value={value}
      onChange={onChange}
      options={agentOptions}
      idField="assistantId"
      search
      emptyMessage="No assistants available"
      withNotSet={!isDefaultPolicy}
      defaultValue={isDefaultPolicy ? false : undefined}
    />
  );
};

export default AgentEntityList;
